import { createTheme } from '@mui/material/styles'

// --color-base-background-1: 243, 247, 245;
//     --color-base-button-background: 90, 111, 102;

export const theme = createTheme({
  palette: {
    primary: {
      main: 'rgb(90, 111, 102)',
    },
    secondary: {
      main: '#847542',
    },
    background: {
      default: 'rgb(243, 247, 245)',
      paper: '#ffffff',
    },
    text: {
      primary: '#101319',
    },
    divider: '#DDDDDD',
    action: {
      hover: '#F9F9F9',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    htmlFontSize: 13.5,
    fontSize: 16,
    fontFamily: 'Cormorant, serif',
    h3: {
      fontSize: '16px',
      fontWeight: '700',
    },
    body1: {
      fontSize: '14px',
      lineHeight: 1.7,
    },
    body2: {
      fontSize: '13px',
      lineHeight: 1.7,
    },
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        outlined: {
          borderColor: '#CCCCCC',
        },
      },
    },
  },
})
